import {
  ISkyWebrootDevice,
  ISubscriberDownloadsInfo,
  WebrootDevicesInfoResponse,
} from "@/common/api/unifiedPortal/interfaces";
import { StatusType } from "@/globalEnums";
import { useSubscriptionsStore } from "@/stores/subscriptions";

export const criticalShields = ["realtimeShield"];

export function getAllWebrootDevices(subscriberInfo: ISubscriberDownloadsInfo) {
  let allDevices: ISkyWebrootDevice[] = [];

  subscriberInfo.webrootSubscriptions.forEach(sub => {
    if (sub.devices && sub.devices.length > 0) {
      allDevices = [...allDevices, ...sub.devices];
    }
  });

  return allDevices;
}

export function calculateStatus(results: WebrootDevicesInfoResponse[]) {
  const devices: ISkyWebrootDevice[] = [];
  for (const result of results) {
    if (result.devices) {
      for (const device of result.devices) {
        //Only count devices that have shields, since we don't want to show a warning for devices that don't have shields like VPN
        if (device.shields) {
          devices.push(device);
        }
      }
    }
  }

  //Hardcoding this for now
  // const state = devices.some(d => !d.shields.realtimeShield)
  //   ? StatusType.danger
  //   : devices.some(
  //         d =>
  //           d.shields.phishingShield === false || // forcing false here, since the shields can be null
  //           d.shields.rootkitShield === false ||
  //           d.shields.webShield === false ||
  //           d.shields.usbShield === false ||
  //           d.shields.offlineShield === false ||
  //           d.shields.identityShield === false
  //       )
  //     ? StatusType.warning
  //     : StatusType.normal;
  // return state;

  return StatusType.normal;
}

export function hasOnlyUninstalledDevices(results: WebrootDevicesInfoResponse[]) {
  for (const result of results) {
    if (result.devices && result.devices.some(d => !d.uninstalled)) {
      return false;
    }
  }
  return true;
}

export function getInstalledDevices(results: WebrootDevicesInfoResponse[]): ISkyWebrootDevice[] {
  const subscriptionStore = useSubscriptionsStore();
  const devices: ISkyWebrootDevice[] = [];

  results.forEach(result => {
    if (result.devices) {
      result.devices?.forEach(d => {
        const subscription = subscriptionStore.subscriptions.find(s => s.keyCode === result.keycode);
        if (subscription && subscription.remainingDays > 0 && (d.isActive ?? true)) {
          // Null means it's active too.
          devices.push(d);
        }
      });
    }
  });
  return devices;
}

export function GetEnabledShieldsCount(devices: ISkyWebrootDevice[]): number {
  let count = 0;
  devices.forEach(device => {
    if (device.shields) {
      if (device.shields.webShield) count++;
      if (device.shields.identityShield) count++;
      if (device.shields.phishingShield) count++;
      if (device.shields.rootkitShield) count++;
      if (device.shields.usbShield) count++;
      if (device.shields.offlineShield) count++;
      if (device.shields.scriptShield) count++;
      if (device.shields.realtimeShield) count++;
    }
  });
  return count;
}

export function GetTotalShieldsCount(devices: ISkyWebrootDevice[]): number {
  let count = 0;
  devices.forEach(device => {
    if (device.shields) {
      if (device.shields.webShield !== null) count++;
      if (device.shields.identityShield !== null) count++;
      if (device.shields.phishingShield !== null) count++;
      if (device.shields.rootkitShield !== null) count++;
      if (device.shields.usbShield !== null) count++;
      if (device.shields.offlineShield !== null) count++;
      if (device.shields.scriptShield !== null) count++;
      if (device.shields.realtimeShield !== null) count++;
    }
  });
  return count;
}
